import { render, staticRenderFns } from "./MyPaperAnswer.vue?vue&type=template&id=153b93ef"
import script from "./MyPaperAnswer.vue?vue&type=script&lang=js"
export * from "./MyPaperAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports